export { it } from '@payloadcms/translations/languages/it'
